import { FolderDocumentManager } from './shared/FolderDocumentManager';

interface DigitalArchiveProps {
  userRole: 'administrator' | 'student' | 'faculty';
  currentUserId?: string;
  currentUserName?: string;
  studentCourse?: string;
}

export function DigitalArchive({ userRole, currentUserId, currentUserName, studentCourse }: DigitalArchiveProps) {
  return (
    <FolderDocumentManager
      userRole={userRole}
      currentUserId={currentUserId || ''}
      currentUserName={currentUserName}
      studentCourse={studentCourse}
    />
  );
}
